module.exports = __webpack_public_path__ + "static/media/rewards-icon.fe8cfbcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/rewards-icon.svg
// module id = 779
// module chunks = 0